<web-design-system-modal [headline]="'savings-plan.add-savings-plan.search-headline' | transloco" (dismiss)="activeModal.close()">
  @if (error) {
    <p class="text-color-error">{{ error | transloco }}</p>
  }
  <web-components-asset-search type="savings-plan-modal" (assetSelected)="pickAsset($event)" [chosenAssets]="currentAssets" />
</web-design-system-modal>
